import { editStatusFilter, unitIdentifierFilter } from '../../Vocabulary/data';
import { QueryFacet } from '../../pages/dashboard/SearchResults';
import { FacetLabel, FacetSetting } from '../../util/types';
import { idHashFilter } from '../../pages/dashboard/utils';
import { HierarchyEntity } from '../data';

export const organisationFacetsSettings: FacetSetting[] = [
  {
    name: 'f_top_orga',
    label: 'search.facet.organisation.top_orga',
    missingLabel: 'search.facet.organisation.top_orga.missing',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.ORGS),
  },
  {
    name: 'f_organisation',
    label: 'search.facet.organisation.organisation',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.ORGS),
  },
  {
    name: 'f_project',
    label: 'search.facet.organisation.project',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.PROJECTS),
  },
  {
    name: 'f_external_identifier',
    label: 'search.facet.organisation.external_identifier',
    tristate: true,
    parse: (facet: QueryFacet): string => `${facet.factor === false ? '-' : ''}${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => unitIdentifierFilter(label),
  },
  {
    name: 'f_editorial_status',
    label: 'search.facet.organisation.editorial_status',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => editStatusFilter(label),
  },
];
